<!-- 안전리더십 > 컨텐츠수행 리스트  -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="nodata-group" v-if="(!isOtherTarget && !isTarget && isUser) || !isActiveLeadership">
        <div class="txt">{{t('message.closedSafetyLeadership')}}</div>
      </div>
      <div class="tit-group ty01" v-if="(isTarget || isOtherTarget || isObserver) && isActiveLeadership">
        <h4 class="tit">{{leadershipData.leadershipTitle}}</h4>
        <div class="btn-group">
          <c-btn02 :btnText="t('message.expandAll')" class="sm" @click="onClickPanel('on')"/>
          <c-btn02 :btnText="t('message.collapseAll')" class="sm" @click="onClickPanel('off')"/>
        </div>
      </div>
      <div class="dropdown-group3" v-if="(isTarget || isOtherTarget || isObserver) && isActiveLeadership">
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel v-for="(item, index) in leadershipData.leadershipTasks">
            <v-expansion-panel-title v-if="_.trim(item.taskTitle) && _.some(item.contentList || [], c => _.trim(c.contentTitle))">
              {{item.taskTitle}}
              <div class="tag-icon-group">
                <div class="tag-icon ty03" v-if="item.reportYn == 'Y'">
                  {{t('message.focusTasks')}}
                </div>
              </div>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div class="list-group3">
                <div class="box" >
                  <ul>
                    <template v-for="(item2, index2) in item.contentList">
                    <li v-if="(isContentUser(item2) || userInfo.roles?.startsWith('ADMIN')) && _.trim(item2.contentTitle)">
                      <v-btn  @click="onClickContent(item, item2)">
                        <span class="t1">
                          {{item2.contentTitle}} {{!utils.isEmpty(item2.targetInfo)?`(${item2.targetInfo})`:''}}
                          <div class="tag-icon-group" v-if="item2.completeYn == 'Y'">
                            <div class="tag-icon ty01">
                              <span class="ico-chk" aria-hidden="true"></span>
                              {{t('message.progressCompleted')}}
                            </div>
                          </div>
                        </span>
                        <span class="t3" v-if="item2.completeYn == 'Y'">
                          {{t('message.recurringCycleNote')}}
                        </span>
                      </v-btn>
                    </li>
                    </template>
                  </ul>
                </div>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>

  <DialogSLR1
    v-model="leadershipRunDialog"
    @close="leadershipRunDialog=false"
    @refresh="refreshPage"
    ref="childRefDialogSLR1"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref, onMounted, watch} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
const { t } = useI18n();

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps({isActive: Boolean})

//bind
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx!='null'?route.params.idx:''
const panel = ref([])
const leadershipData:any = ref({})
const leadershipRunDialog = ref(false)
const childRefDialogSLR1 = ref(null)
const isReportTarget = ref(false) //리포트유저
const isTarget = ref(false) //리더십 대상자
const isOtherTarget = ref(false) //리더십 대상자는 아니지만 타인관찰 대상자
const isActiveLeadership = ref(false)
const isObserver = ref(false) //리더십 대상자는 아닌 관리자
const userInfo = JSON.parse(localStorage.getItem('user'))
const isUser = ref(userInfo.roles=='USER')

//hook
onMounted(() => {
})

//function
const getLeadership=async()=>{
  let params = {
    idx: viewIdx
  }

  try{
    const response:any = await LeadershipService.getLeadership(params)
    if (response.success) {
      leadershipData.value = response.result
      //리포트열람자 확인
      if(_.some(leadershipData.value.reportTargets, {idx:userInfo.memberIdx}))
        isReportTarget.value = true
      //리더십대상자 확인
      if(_.some(leadershipData.value.leadershipTargets, {idx:userInfo.memberIdx}))
        isTarget.value = true
      //타인관찰 대상자 확인 (리더십 속하지않음)
      const otherTargetList = leadershipData.value.leadershipTasks
        .flatMap(task => task.contentList)
        .filter(item => item.leadershipTargetIdx == userInfo.memberIdx || (!item.leadershipTargetIdx && item.monitoringTargetIdx == userInfo.memberIdx) )
      if(otherTargetList.length > 0)
        isOtherTarget.value = true
      //리더십 대상자는 아닌 관리자
      if(!isReportTarget.value && !isTarget.value && userInfo.roles.startsWith('ADMIN'))
        isObserver.value = true
      else
        isObserver.value = false
      //종료여부 확인
      const now = dayjs()
      const allContents = _.flatMap(leadershipData.value.leadershipTasks, 'contentList')
      const maxPeriodSeq = _.maxBy(allContents, 'periodSeq')?.periodSeq || 0
      isActiveLeadership.value = now.isSameOrAfter(dayjs(leadershipData.value.startDate)) && now.isSameOrBefore(dayjs(leadershipData.value.endDate), 'day') && maxPeriodSeq > 0
      onClickPanel('on')
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onClickPanel=(type)=> {
  let panelList = []
  _.forEach(leadershipData.value.leadershipTasks, (val, key)=>{
    panelList.push(key)
  })
  if(type == 'on')
    panel.value = panelList
  else if(type == 'off')
    panel.value = []
}

const onClickContent=(taskItem, contentItem)=>{
  storeRef.selectedTask.value = taskItem
  storeRef.selectedContent.value = contentItem
  childRefDialogSLR1.value.childRefLoadData()
  storeRef.isObserver.value = isObserver.value  //리더십 수행하지 않는 관찰자(관리자)
  leadershipRunDialog.value=true
}

const refreshPage=()=>{
  getLeadership()
}

//상세내역 참여자인지 확인
const isContentUser=(item)=>{
  //타인관찰 아니면
  if(item.contentType != '4' && item.leadershipTargetIdx == userInfo.memberIdx)
    return true
    //타인관찰이고, 리더십 내부관찰자면 두값모두있어야되고, 리더십 외부 관찰자면 1번은 널 2번은 있어야함
  else if(item.contentType == '4' && ((item.leadershipTargetIdx == userInfo.memberIdx && item.monitoringTargetIdx == userInfo.memberIdx) || (!item.leadershipTargetIdx && item.monitoringTargetIdx == userInfo.memberIdx)))
    return true
  else
    return false
}

//watch
watch(() => props.isActive, (val, oldVal) => {
  if (val)
    getLeadership()
},{ immediate: true })
</script>


<style lang="scss" >
</style>
